<template>
    <div
        class="side-panel"
        @click.self="$emit('close')"
    >
        <div class="panel">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.side-panel {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: $mask;
    z-index: 999;
    @include flex-row(flex-end, stretch);

    .panel {
        box-shadow: 0 0 6px $shadow;
        background-color: #fff;
        min-width: 400px;
    }
}
</style>
